var map = {
	"./npc_dota_hero_abaddon.webm": "cad7",
	"./npc_dota_hero_abyssal_underlord.webm": "3439",
	"./npc_dota_hero_alchemist.webm": "0b423",
	"./npc_dota_hero_ancient_apparition.webm": "5f91",
	"./npc_dota_hero_antimage.webm": "532e",
	"./npc_dota_hero_arc_warden.webm": "a07b",
	"./npc_dota_hero_armadillo.webm": "ca36",
	"./npc_dota_hero_axe.webm": "cbcf",
	"./npc_dota_hero_bane.webm": "65e1",
	"./npc_dota_hero_batrider.webm": "2e9c",
	"./npc_dota_hero_beastmaster.webm": "007e",
	"./npc_dota_hero_bloodseeker.webm": "0e82",
	"./npc_dota_hero_bounty_hunter.webm": "0791",
	"./npc_dota_hero_brewmaster.webm": "febc",
	"./npc_dota_hero_bristleback.webm": "954e",
	"./npc_dota_hero_broodmother.webm": "6b42",
	"./npc_dota_hero_centaur.webm": "e25b",
	"./npc_dota_hero_chaos_knight.webm": "1a71",
	"./npc_dota_hero_chen.webm": "e07c",
	"./npc_dota_hero_clinkz.webm": "0fb4",
	"./npc_dota_hero_crystal_maiden.webm": "95ea",
	"./npc_dota_hero_dark_seer.webm": "57b7",
	"./npc_dota_hero_dark_willow.webm": "9d85",
	"./npc_dota_hero_dawnbreaker.webm": "fbf7",
	"./npc_dota_hero_dazzle.webm": "c12d",
	"./npc_dota_hero_death_prophet.webm": "bbd2",
	"./npc_dota_hero_disruptor.webm": "4e0c",
	"./npc_dota_hero_doom_bringer.webm": "bf12",
	"./npc_dota_hero_dragon_knight.webm": "4acd",
	"./npc_dota_hero_drow_ranger.webm": "a97e",
	"./npc_dota_hero_earth_spirit.webm": "9ab9",
	"./npc_dota_hero_earthshaker.webm": "4499",
	"./npc_dota_hero_elder_titan.webm": "bf32",
	"./npc_dota_hero_ember_spirit.webm": "1029",
	"./npc_dota_hero_enchantress.webm": "2b20",
	"./npc_dota_hero_enigma.webm": "5321",
	"./npc_dota_hero_faceless_void.webm": "8c29",
	"./npc_dota_hero_furion.webm": "f6ee",
	"./npc_dota_hero_grimstroke.webm": "cfa8",
	"./npc_dota_hero_gyrocopter.webm": "e5db",
	"./npc_dota_hero_hoodwink.webm": "6fbb",
	"./npc_dota_hero_huskar.webm": "5ac2",
	"./npc_dota_hero_invoker.webm": "8aa6",
	"./npc_dota_hero_jakiro.webm": "5dad",
	"./npc_dota_hero_juggernaut.webm": "0550",
	"./npc_dota_hero_keeper_of_the_light.webm": "023e",
	"./npc_dota_hero_kez.webm": "dbd1",
	"./npc_dota_hero_kunkka.webm": "b603",
	"./npc_dota_hero_largo.webm": "1d66",
	"./npc_dota_hero_legion_commander.webm": "976d",
	"./npc_dota_hero_leshrac.webm": "a130",
	"./npc_dota_hero_lich.webm": "9b65",
	"./npc_dota_hero_life_stealer.webm": "6e82",
	"./npc_dota_hero_lina.webm": "0f06",
	"./npc_dota_hero_lion.webm": "f2a6",
	"./npc_dota_hero_lone_druid.webm": "a8f3",
	"./npc_dota_hero_luna.webm": "03bf",
	"./npc_dota_hero_lycan.webm": "9873",
	"./npc_dota_hero_magnataur.webm": "f87c",
	"./npc_dota_hero_marci.webm": "753e",
	"./npc_dota_hero_mars.webm": "673c",
	"./npc_dota_hero_medusa.webm": "2264",
	"./npc_dota_hero_meepo.webm": "64c0",
	"./npc_dota_hero_mirana.webm": "9461",
	"./npc_dota_hero_monkey_king.webm": "e0bc",
	"./npc_dota_hero_morphling.webm": "5441",
	"./npc_dota_hero_muerta.webm": "78f6",
	"./npc_dota_hero_naga_siren.webm": "9e66",
	"./npc_dota_hero_necrolyte.webm": "d933",
	"./npc_dota_hero_nevermore.webm": "15bc",
	"./npc_dota_hero_night_stalker.webm": "ce0f",
	"./npc_dota_hero_nyx_assassin.webm": "35bb",
	"./npc_dota_hero_obsidian_destroyer.webm": "01f1",
	"./npc_dota_hero_ogre_magi.webm": "61fc",
	"./npc_dota_hero_omniknight.webm": "7711",
	"./npc_dota_hero_oracle.webm": "a0a4",
	"./npc_dota_hero_pangolier.webm": "fd66",
	"./npc_dota_hero_phantom_assassin.webm": "edde",
	"./npc_dota_hero_phantom_lancer.webm": "d474",
	"./npc_dota_hero_phoenix.webm": "9a19",
	"./npc_dota_hero_primal_beast.webm": "7eb3",
	"./npc_dota_hero_puck.webm": "66f7",
	"./npc_dota_hero_pudge.webm": "5dd9",
	"./npc_dota_hero_pugna.webm": "c444",
	"./npc_dota_hero_queenofpain.webm": "4213",
	"./npc_dota_hero_rattletrap.webm": "f280",
	"./npc_dota_hero_razor.webm": "0b08",
	"./npc_dota_hero_riki.webm": "47b2",
	"./npc_dota_hero_ringmaster.webm": "1fdb",
	"./npc_dota_hero_rubick.webm": "8490",
	"./npc_dota_hero_sand_king.webm": "5917",
	"./npc_dota_hero_shadow_demon.webm": "24ad",
	"./npc_dota_hero_shadow_shaman.webm": "86b0",
	"./npc_dota_hero_shredder.webm": "facb",
	"./npc_dota_hero_silencer.webm": "82b1",
	"./npc_dota_hero_skeleton_king.webm": "ea04",
	"./npc_dota_hero_skywrath_mage.webm": "5aa1",
	"./npc_dota_hero_slardar.webm": "b64c",
	"./npc_dota_hero_slark.webm": "6ca1",
	"./npc_dota_hero_snapfire.webm": "f6de",
	"./npc_dota_hero_sniper.webm": "bc94",
	"./npc_dota_hero_spectre.webm": "be06",
	"./npc_dota_hero_spirit_breaker.webm": "76dd",
	"./npc_dota_hero_storm_spirit.webm": "6de3",
	"./npc_dota_hero_sven.webm": "504c",
	"./npc_dota_hero_sylph.webm": "c21c",
	"./npc_dota_hero_techies.webm": "3e86",
	"./npc_dota_hero_templar_assassin.webm": "96c7",
	"./npc_dota_hero_terrorblade.webm": "0fb8",
	"./npc_dota_hero_tidehunter.webm": "e5b6",
	"./npc_dota_hero_tinker.webm": "072d",
	"./npc_dota_hero_tiny.webm": "5ae4",
	"./npc_dota_hero_treant.webm": "8a15",
	"./npc_dota_hero_troll_warlord.webm": "206a",
	"./npc_dota_hero_tusk.webm": "d231",
	"./npc_dota_hero_undying.webm": "abcc",
	"./npc_dota_hero_ursa.webm": "ae45",
	"./npc_dota_hero_vengefulspirit.webm": "fcbb",
	"./npc_dota_hero_venomancer.webm": "c3d1",
	"./npc_dota_hero_viper.webm": "17a0",
	"./npc_dota_hero_visage.webm": "e04c",
	"./npc_dota_hero_void_spirit.webm": "55f8",
	"./npc_dota_hero_warlock.webm": "f4b5",
	"./npc_dota_hero_weaver.webm": "512b",
	"./npc_dota_hero_windrunner.webm": "38c8",
	"./npc_dota_hero_winter_wyvern.webm": "f375",
	"./npc_dota_hero_wisp.webm": "0146",
	"./npc_dota_hero_witch_doctor.webm": "983b",
	"./npc_dota_hero_zuus.webm": "db3b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "531f";